import { Dropdown, Menu } from "antd";
import React, { useState } from "react";
import arrow from "../../../assets/svgs/header-icon/arrow-down.svg";
import arrowGrey from "../../../assets/svgs/header-icon/arrow-down-grey.svg";
import { dateAdded } from "../FilterItems/FilterItems";
import SpMenu from "../../SpMenu/SpMenu";

const DateAdded = ({onChange}) => {
  const [date, setDate] = useState("Date Added");
  const [selected, setSelected] = useState(false);

  function handleFilterSelect({item, index}) {
    setDate(item?.date?? 'All');
    setSelected(true);

    if (typeof onChange === "function") {
      onChange(item?.date?? '');
    }
  }

  const menu = (
    <SpMenu items={dateAdded} renderItem={(item) => <p>{item.date}</p>} onSelect={handleFilterSelect} />
  );


  return (
    <div className="filter-modal-inner">
      <p>Date Added</p>
      <Dropdown overlay={menu} trigger={["click"]}>
        <button
          className={
            selected ? "selected filter-modal-btn" : "filter-modal-btn"
          }
        >
          {" "}
          {date}
          <span className="filter-icon">
            {selected ? (
              <img src={arrow} alt="/" />
            ) : (
              <img src={arrowGrey} alt="/" />
            )}
          </span>{" "}
        </button>
      </Dropdown>
    </div>
  );
};

export default DateAdded;
